import { Controller } from "stimulus"

/**
 * This controller allows you to wait a specified delay after the animation completes before playing it again.
 * Impossible in the current Lottie Player API, so we have to do it manually.
 */
export default class extends Controller {
  static values = {
    src: String,
    speed: { type: Number, default: 1 },
    delay: { type: Number, default: 1500 },
    playMode: { type: String, default: "normal" }
  }

  connect() {
    // Create the lottie-player element
    this.player = this.element.querySelector('lottie-player')
    if (!this.player) return

    // Set up the player attributes
    this.player.setAttribute('src', this.srcValue)
    this.player.setAttribute('autoplay', 'true')
    this.player.setAttribute('speed', this.speedValue)
    this.player.setAttribute('playMode', this.playModeValue)

    // We handle looping ourselves to remove attribute
    this.player.removeAttribute('loop')

    // Add event listener for animation complete
    this.player.addEventListener('complete', this.handleComplete.bind(this))
  }

  disconnect() {
    if (this.player) {
      this.player.removeEventListener('complete', this.handleComplete.bind(this))
    }
  }

  handleComplete() {
    // When animation completes, wait for delay then play again
    setTimeout(() => {
      if (this.player) {
        this.player.seek(0)
        this.player.play()
      }
    }, this.delayValue)
  }
}
